import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { FiX } from 'react-icons/fi';
import axios from 'axios';
import { BASE_URL } from '../constants/config';
import { getTokensFromStore, checkIfTokenExpired } from '../utilities/tokens';
import { refreshTokens } from '../actions/usersActions';
import { useI18n } from '../utilities/i18n';
import '../styles/createMatchModal.css';

function CreateStageModal({ isOpen, onClose, onSuccess, league, season }) {
  const dispatch = useDispatch();
  const { t } = useI18n();
  
  const [stageName, setStageName] = useState('');
  const [stageShortName, setStageShortName] = useState('');
  const [isPlayoff, setIsPlayoff] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!stageName.trim()) {
      setMessage({ text: t('stNameRequired'), type: 'error' });
      return;
    }

    setLoading(true);
    setMessage({ text: '', type: '' });

    try {
      const isTokenExpired = checkIfTokenExpired();
      if (isTokenExpired) {
        await dispatch(refreshTokens());
      }
      const tokens = getTokensFromStore();

      // Вычисляем priority на основе настроек лиги и чекбокса плей-офф
      let priority = 1;
      if (league.league_type === 2 && league.group_stages_amount) {
        if (isPlayoff) {
          priority = league.group_stages_amount + 1;
        } else {
          priority = league.group_stages_amount - 1;
        }
      }

      const stageData = {
        name: stageName.trim(),
        short_name: stageShortName.trim() || null,
        priority: priority,
        group_id: null,
        league_id: parseInt(league.value),
        season_id: parseInt(season.value),
        stages_amount: 1,
        matches: []
      };

      const response = await axios.post(
        BASE_URL.url + `/leagues/${league.value}/addStage`,
        stageData,
        {
          headers: {
            Authorization: "Bearer " + tokens.access_token,
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      );

      setMessage({ text: t('stCreated'), type: 'success' });
      setTimeout(() => {
        resetForm();
        if (onSuccess) onSuccess();
        onClose();
      }, 1500);
    } catch (error) {
      console.error('Error creating stage:', error);
      setMessage({ 
        text: error.response?.data?.message || t('stCreateError'), 
        type: 'error' 
      });
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setStageName('');
    setStageShortName('');
    setIsPlayoff(false);
    setMessage({ text: '', type: '' });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal-content create-match-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{t('stCreateTitle')}</h2>
          <button className="modal-close" onClick={onClose} type="button">
            <FiX size={24} />
          </button>
        </div>
      
        <div className="modal-body">
          {message.text && (
            <div className={`message-box ${message.type === 'success' ? 'message-success' : 'message-error'}`}>
              {message.text}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-section-modal">
              <label className="form-label-modal form-label-required">
                {t('stName')}
              </label>
              <input
                className="input-field-modal"
                type="text"
                value={stageName}
                onChange={(e) => setStageName(e.target.value)}
                placeholder={t('stNamePh')}
                maxLength={100}
              />
            </div>

            <div className="form-section-modal">
              <label className="form-label-modal">
                {t('stShortName')}
              </label>
              <input
                className="input-field-modal"
                type="text"
                value={stageShortName}
                onChange={(e) => setStageShortName(e.target.value)}
                placeholder={t('stShortPh')}
                maxLength={50}
              />
            </div>

            <div className="form-section-modal">
              <label className="checkbox-item-modal">
                <input
                  type="checkbox"
                  checked={isPlayoff}
                  onChange={(e) => setIsPlayoff(e.target.checked)}
                />
                {t('stPlayoff')}
              </label>
            </div>

            <div className="button-group-modal">
              <button
                type="submit"
                disabled={loading}
                className="btn-modal btn-primary-modal"
              >
                {loading ? t('stCreating') : t('stCreateBtn')}
              </button>

              <button
                type="button"
                onClick={onClose}
                disabled={loading}
                className="btn-modal btn-secondary-modal"
              >
                {t('cancel')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateStageModal;
